import Vue from 'vue'
import Router from 'vue-router'
import VueI18n from 'vue-i18n'
import Zhrouter from '@/router/zh_index.js'
import Enrouter from '@/router/en_index.js'
Vue.use(Router)
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: localStorage.getItem('languageSet') || 'zh',
  messages: {
    'zh': require('../components/language/zh'),
    'en': require('../components/language/en')
  }
})
// eslint-disable-next-line eqeqeq
let routers = i18n.locale == 'zh' ? Zhrouter : Enrouter
export default new Router({
  routes: [...routers]
})



// WEBPACK FOOTER //
// ./src/router/index.js